import { EventEmitter, OnDestroy, Output, VERSION, inject } from "@angular/core";
import { OnInit } from "@angular/core";
import { Component } from "@angular/core";
import { Subject } from "rxjs";
import packageJson from "../../package.json";
import { AuthorizationService } from "./shared/services/authorization.service";
import { AppReadyService } from "./shared/services/app-ready.service";
import { CommonModule } from "@angular/common";
import { HeaderComponent } from "./core/components/header/header.component";
import { SidebarComponent } from "./core/components/sidebar/sidebar.component";
import { MainContentComponent } from "./core/components/main-content/main-content.component";
import { ToastComponent } from "./shared/components/layout/toast/toast.component";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthInterceptor } from "./shared/interceptors/auth.interceptor";
import { MsalInterceptor } from "@azure/msal-angular";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: true,
    imports: [CommonModule, HeaderComponent, SidebarComponent, MainContentComponent, ToastComponent],
    providers: [
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true,
      }
    ]
})
export class AppComponent implements OnInit, OnDestroy {
  private auth = inject(AuthorizationService);
  private appReadyService = inject(AppReadyService);

  @Output() eventFromHeader = new EventEmitter<any>();

  mobileMenuOpen = false;
  public angularVersion: string = VERSION.full;

  private readonly _destroying$ = new Subject<void>();
  public appVersion: string = packageJson.version;

  ngOnInit(): void {
    this.appReadyService.markAppAsReady();
    this.auth.validateUser().subscribe();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  handleEvent($event: any) {
    switch ($event.type) {
      case "showMobileMenu":
        this.mobileMenuOpen = $event.value;
        break;
    }
  }
}
